import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};

export const applyGlintTheme = theme => {
  if (!theme) return;

  const {
    navigation = 'light',
    header = 'light',
    skin = 'light',
    typography = 'system_ui',
  } = theme;

  const html = document.documentElement;

  // Remove existing classes
  const classesToRemove = Array.from(html.classList).filter(
    c =>
      c.startsWith('app-navigation-') ||
      c.startsWith('app-header-') ||
      c.startsWith('app-skin-') ||
      c.startsWith('app-font-family-')
  );
  classesToRemove.forEach(c => html.classList.remove(c));

  // Add new classes
  html.classList.add(`app-navigation-${navigation}`);
  html.classList.add(`app-header-${header}`);
  html.classList.add(`app-skin-${skin}`);
  html.classList.add(`app-font-family-${typography.replace(/_/g, '-')}`);

  // Update localStorage to keep it in sync with the database theme
  LocalStorage.set('app-navigation', `app-navigation-${navigation}`);
  LocalStorage.set('app-header', `app-header-${header}`);
  LocalStorage.set('app-skin', `app-skin-${skin}`);
  LocalStorage.set('app-skin-dark', `app-skin-${skin}`);
  LocalStorage.set('color_scheme', skin);
  LocalStorage.set(
    'font-family',
    `app-font-family-${typography.replace(/_/g, '-')}`
  );

  // Apply color scheme (dark mode)
  setColorTheme(skin === 'dark');
};
